import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import UsersActions, { UsersRedux, UsersTypes } from '../Redux/UsersRedux'
import { AuthRedux } from 'auth-advenio'
import { COOKIE_DOMAIN } from '../../config'

const usersCrudObservable = createCRUDObservable({
  mainRedux: UsersRedux,
  reduxPath: 'users',
  dataHandlers: {
    get: response => response.data.data,
  },
})
const postUserPictureEpic = (action$, store, { Api }) => (
  action$
    .ofType(UsersRedux.Types.postUserPicutreRequest)
    .mergeMap(({ id, data }) => (
      Observable
        .fromPromise(
          Api.users.postUserPicture(id, data)
            .then(response => response)
            .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              UsersActions.postUserPicutreError(response.error),
            ]
          }
          // const pagination = store.getState().auth.users
          const { data } = response.data
          const user = data,
            authenticated = true,
            tokenExpiresAt = new Date(Date.now() + (3600000 * 1000))

          document.cookie = `advenio_user=${JSON.stringify(user)}; domain=${COOKIE_DOMAIN}; expires=${tokenExpiresAt}; path=/;`
          const actions = () => ([{
            type: AuthRedux.Types.setAuthStatus,
            authenticated,
            user,
          }, UsersActions.postUserPicutreSuccess()])
          return actions()
        })
    ))
)
export const usersObservers = Object.assign({}, usersCrudObservable.observers, {})

export const usersEpic = combineEpics(
  usersCrudObservable.epic,
  postUserPictureEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/UsersObservable.js